import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { staticRoutes } from '@atlas/routing';

const useSignInRedirects = () => {
  const history = useHistory();

  const redirectToSignIn = useCallback(
    // This can be custom data that should be preserved in the location state
    // for further usage after login for correct actions (see redirectAfterSignIn function)
    data => {
      history.push(staticRoutes.signin, { data, prevLocation: history.location });
    },
    [history],
  );

  const redirectAfterSignIn = useCallback(() => {
    const { pathname = '', search = '' } = history.location.state?.prevLocation || {};
    const data = history.location.state?.data;

    history.replace(`${pathname}${search}` || '/', data);
  }, [history]);

  return { redirectAfterSignIn, redirectToSignIn };
};

export default useSignInRedirects;
